













import Vue from 'vue'
import style from './style.module.scss'

export default Vue.extend({
name: 'info-block',
  components: {

  },
  props: {
    header: String,
    needBorder: {
      type: Boolean,
      required: false,
      default: true
    }
  },
  data() {
    return {
    style: style
    }
  },
})
